<script>
export default {
    props: {
        layout: {
            type: Object,
            default: function() {
                return {
                    label: 6,
                    wrapper: 16
                };
            }
        },
        information: {
            type: Number,
        }
    },
    created() {
        if (this.editing) {
            this.preload = true;
            this.getItem();
        }
    },
    computed: {
        editing() {
            return this.information !== "";
        }
    },
    data() {
        return {
            form: this.$form.createForm(this),
            preload: false,
            processing: false,
            item: {},
            fileList: []
        };
    },
    methods: {
        getItem() {
            this.$http
                .get(
                    this.routeUri("api.information.show", {
                        information: this.information
                    })
                )
                .then(res => (this.item = res.data))
                .finally(() => (this.preload = false));
        },
        handleClose() {
            this.$emit("handleClose", false);
        },
    },
};
</script>

<template>
    <a-card type="inner" size="small">
        <a-row type="flex">
            <a-col><h1>{{ item.title }}</h1></a-col>
        </a-row>
        <a-row type="flex"  style="margin-top: 10px">
            <a-col>
                <div v-html="item.description">
                </div>
            </a-col>
        </a-row>
        <a-row type="flex"  style="margin-top: 20px">
            <a-col>
                <a-button type="link" size="small" :href="item.attachment"
                    v-if="item.attachment != null">
                    <a-icon type="file-pdf" theme="twoTone" two-tone-color="#eb3437" /> Download
                </a-button>
            </a-col>
        </a-row>
        <a-row type="flex" justify="end">
            <a-col>
                <a-button
                    @click="handleClose"
                    :loading="processing"
                    :disabled="processing"
                    style="margin-left: 24px"
                    >Tutup</a-button
                >
            </a-col>
        </a-row>
    </a-card>
</template>
